import { render } from "./HeaderNotification.vue?vue&type=template&id=2dd93b88&ts=true"
import script from "./HeaderNotification.vue?vue&type=script&lang=ts"
export * from "./HeaderNotification.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__